import { ApiResponse, TicketManagerPool } from '@vision/ui/interfaces';

interface TicketManagerPoolResponseDto {
  id: string;
  name: string;
  node_id: string;
  project_id: string;
  ticket_count?: number;
}

export function normalizeTicketManagerPool(dto: TicketManagerPoolResponseDto): TicketManagerPool {
  return {
    id: dto.id,
    name: dto.name,
    nodeId: dto.node_id,
    projectId: dto.project_id,
    ticketCount: dto.ticket_count,
  };
}

export function normalizeTicketManagerPoolsResponse(
  response: ApiResponse<TicketManagerPoolResponseDto[]>,
): ApiResponse<TicketManagerPool[]> {
  return {
    ...response,
    data: response.data.map(normalizeTicketManagerPool),
  };
}

export function normalizeTicketManagerPoolResponse(
  response: ApiResponse<TicketManagerPoolResponseDto>,
): ApiResponse<TicketManagerPool> {
  return {
    ...response,
    data: normalizeTicketManagerPool(response.data),
  };
}
